import { buttonGroupProps as s } from "./index728.js";
import { defineComponent as u, provide as m, reactive as a, toRef as t, openBlock as i, createElementBlock as c, normalizeClass as l, unref as r, renderSlot as f } from "vue";
import { buttonGroupContextKey as d } from "./index608.js";
import { useNamespace as b } from "./index559.js";
var B = /* @__PURE__ */ u({
  name: "ElButtonGroup",
  __name: "button-group",
  props: s,
  setup(n) {
    const o = n;
    m(
      d,
      a({
        size: t(o, "size"),
        type: t(o, "type")
      })
    );
    const e = b("button");
    return (p, _) => (i(), c(
      "div",
      {
        class: l([r(e).b("group"), r(e).bm("group", o.direction)])
      },
      [
        f(p.$slots, "default")
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  B as default
};
